import React from "react";
import { useLang } from "../LanguageContext";

const SERVICE_URL =
  process.env.REACT_APP_CAMPER_MONITOR_URL ||
  "https://camper-monitor-347621148423.europe-north1.run.app";

function CamperMonitor() {
  const { t } = useLang();
  const showsItems    = t("camperMonitor.showsItems");
  const hardwareItems = t("camperMonitor.hardwareItems");

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">{t("camperMonitor.label")}</span>
        <div className="subhead">{t("camperMonitor.title")}</div>
        <p className="section-intro-inner">{t("camperMonitor.intro")}</p>
      </div>

      <div className="showcase-layout">
        <div className="showcase-main">

          <div className="tool-card showcase-card">
            <h3>{t("camperMonitor.overviewTitle")}</h3>
            <p>{t("camperMonitor.overview1")}</p>
            <p>{t("camperMonitor.overview2")}</p>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("camperMonitor.showsTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(showsItems) && showsItems.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("camperMonitor.hardwareTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(hardwareItems) && hardwareItems.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>

          {SERVICE_URL ? (
            <div className="tool-card showcase-card">
              <h3>{t("camperMonitor.demoTitle")}</h3>
              <p className="section-intro-inner" style={{padding:0, marginBottom:"1rem"}}>
                {t("camperMonitor.demoSubtitle")}
              </p>
              <div className="iframe-container">
                <iframe src={SERVICE_URL} title={t("camperMonitor.title")} allowFullScreen />
              </div>
            </div>
          ) : (
            <div className="tool-card showcase-card showcase-card--placeholder">
              <h3>{t("camperMonitor.demoTitle")}</h3>
              <p>{t("camperMonitor.demoPlaceholder")}</p>
            </div>
          )}

        </div>

        <div className="showcase-sidebar">
          <div className="tool-card showcase-links-card">
            <div className="showcase-app-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="12" rx="1.5"/>
                <line x1="2" y1="11" x2="22" y2="11"/>
                <rect x="4" y="7" width="5" height="4" rx="0.5"/>
                <rect x="11" y="7" width="4" height="4" rx="0.5"/>
                <circle cx="7" cy="19" r="2"/>
                <circle cx="17" cy="19" r="2"/>
              </svg>
            </div>
            <h3>{t("camperMonitor.title")}</h3>
            <div className="project-tags" style={{marginBottom:"1.25rem"}}>
              <span className="tool-tag">Node.js</span>
              <span className="tool-tag">React</span>
              <span className="tool-tag">BLE</span>
              <span className="tool-tag">Raspberry Pi</span>
            </div>
            <div className="showcase-btn-col">
              <a href="https://github.com/its-really-me/camper-monitor" target="_blank" rel="noreferrer" className="showcase-btn showcase-btn--primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
                </svg>
                {t("camperMonitor.github")}
              </a>
            </div>
            <div className="showcase-screenshot">
              <img src="/images/camper-monitor.png" alt={t("camperMonitor.title")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CamperMonitor;
